import React, { useState,useEffect } from "react";
import CourseModal from "./CourseModal";
import CoursesDiv from "./CoursesDiv";
import EducationDiv from "./EducationDiv";
import EducationModal from "./EducationModal";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';


function CandidateOverviewEducationCourses({educationData,coursesData,getUpdatedData}) {

const [education,setEducation]=useState(educationData)
const [courses,setCourses]=useState(coursesData)
const [editData,setEditData]=useState({})
const [educationModal,setEducationModal]=useState(false)
const [courseModal,setCourseModal]=useState(false)

// console.log({education})
// console.log({courses})
 
useEffect(()=>{
setEducation(educationData)
setCourses(coursesData)
},[educationData,coursesData])


const onEditEducationData=(data)=>{
setEditData(data)
setEducationModal(true)
}

const onEditCourseData=(data)=>{
  setEditData(data)
  setCourseModal(true)
  }

const onAddEducationData=()=>{
  
    setEditData({})
    setEducationModal(true)
    }
    
const onAddCourseData=()=>{
      setEditData({}) 
      setCourseModal(true)
   }
 
    

  return (
    <>
  
      <div className="candidate-about__r9-education">
      <div style={{borderBottom: '1px solid rgba(238, 239, 243, 0.95)',marginBottom:'20px',paddingLeft:'41px'}}>
      <div className='container_sections_wrapper'>

          <h3 style={{ fontWeight:'700',
  fontSize:'17px',color: '#373a40'}}>Education</h3>
         <div onClick={onAddEducationData} className="add_icon">
          <AddCircleOutlineIcon fontSize="large" style={{marginTop:'3px',marginLeft:'45px'}} />
          </div>       
          
             </div>


        <div className="r9-education__c1-education-div">
          {
            education && 
              education?.map((degree, i) => {
                return <EducationDiv key={i} degree={degree} onEdit={onEditEducationData} />;
              })
            // : (
            //   <EducationDiv degree={[1, 2]} />
            // )
          }
        </div> 
        </div>


        <div className="candidate-about__r10-courses">
        <div className='container_sections_wrapper'>
           <h3 style={{ fontWeight:'700',
  fontSize:'17px',color: '#373a40'}}>Certifications and Courses</h3>
          <div onClick={onAddCourseData} className="add_icon">
          <AddCircleOutlineIcon fontSize="large" style={{marginTop:'3px',marginLeft:'45px'}} />
          </div>

          </div>
          <div className="r10-courses__c2-courses-div">
            {
              courses &&
              courses?.length > 0 &&
              courses?.map((certificate, i) => {
                  return <CoursesDiv certificate={certificate} key={i} onEdit={onEditCourseData}/>;
                })
              // : ( 
              //   <CoursesDiv certificate={[1, 2]} />
              // )
            }
          </div> 
          </div>

    
      </div>

        {educationModal && (<EducationModal editData={editData} isVisible={educationModal} onClose={()=>{

          getUpdatedData()
          setEducationModal(!educationModal)
          }
          }/>)}
        {courseModal && (<CourseModal editData={editData} isVisible={courseModal} onClose={()=>{
          getUpdatedData()
         setCourseModal(!courseModal) 
        }
          }/>)}
          
    </>
  );
}

export default CandidateOverviewEducationCourses;
